import React from 'react'

import { Body1, Heading3, Link, Space } from '@gousto-internal/citrus-react'

export const Websites: React.FC = () => (
  <section id="websites" aria-labelledby="websites-heading">
    <Space size={6} />
    <Heading3 size={[5, null, 7]}>We have two different types of websites:</Heading3>
    <Space size={2} />

    <Body1>
      <ul>
        <li>
          Our main website (gousto.co.uk) – where you can browse recipes, sign up, and manage your
          account; and
        </li>
        <li>
          Our landing pages (<strong>cook</strong>.gousto.co.uk) – to host additional pages, that
          sit alongside our main website.
        </li>
      </ul>
      <Space size={2} />
      If you search for “Gousto” on Google, you might land on either of these. Both use cookies, but
      they’re managed separately:
      <ul>
        <li>
          On gousto.co.uk, you can update your cookie settings anytime using the cookie banner or
          the site’s cookie settings tool. See section 3 of the Cookie Policy below for more
          details.
        </li>
        <li>
          On <strong>cook</strong>.gousto.co.uk, the settings don’t carry over from the main
          website.
        </li>
      </ul>
      👉 To change your cookie settings on <strong>cook</strong>.gousto.co.uk, click{' '}
      <Link
        href="https://cook.gousto.co.uk/cookie-policy/"
        target="_blank"
        rel="noopener noreferrer"
      >
        here
      </Link>
      .
    </Body1>
    <Space size={6} />
  </section>
)
